export default "__VITE_ASSET__hKIZAv5c__"